import React from 'react'
import imgUrl from '../assets/images/imgUrl'
import Typography from '@mui/material/Typography'

function Events() {
  return (
    <div className='homeMainWrapper biographyWrapper awardsWrapper thoughtLeadershipwrapper eventsWrapper'>
      <div className='homeBackground'>
            <div className='upperImage'>
            <img src={imgUrl.smileLogo} alt='smile logo'></img>
            </div>
      </div>

      {/* events and annoucements section */}
      <section>
        <div className='dynamicBannerwrapper lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>

             <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>
            
             <div className='iconBackground'>
                <img src={imgUrl.announcement} alt='icon'></img>
             </div>
            
             <Typography className='headings sectionHeading blackTitles lifeStorytitle'>Event Calendar & Announcements</Typography>

              <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-10px'>
                Keep track of <b> Dr. Huzaifa Khorakiwala’s </b>upcoming engagements, public
                appearances and initiative launches through our <span className='font-italic'> Event Calendar.  </span>This
                interactive calendar highlights key dates and provides details for each
                event:
              </Typography>
        </div>
      </section>

      {/* conferences and summits section */}
      <section>
         <div className='whiteSection lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
            <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

                <div className='iconBackground iconYellowbg'>
                <img src={imgUrl.summit} alt='icon'></img>
                </div>

            <Typography className='headings sectionHeading sectionShorttitle'>Conferences & Summits</Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-10px'>
               <b> Global Justice, Love and Peace Summit – 12th–13th April 2025, Dubai, UAE </b> <br/>
               The <span className='font-italic'> Global Justice, Love & Peace Summit at Dubai Expo City </span> gathered
              <b> Nobel Peace Laureates, </b> global leaders and humanitarians. Highlights
              included the unveiling of the inspirational <span className='font-italic'> Peace Charter: Love Letter to
              Humanity, </span> embodying universal compassion and unity. Exceptional
              contributors to peace received the esteemed <b> EIRENE Awards, </b>celebrating
              global champions of Justice, Love & Peace.
             </Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-10px'>
              <b> Billionaires for Peace Conclave – 2nd April 2026, Dubai, UAE</b> <br/>
              The prestigious <span className='font-italic'>Billionaires for Peace Conclave </span> will unite <b> 210 Billionaires </b>
              (<b> I Am Peacekeeper Patrons </b>) with <b> 7 Nobel Peace Laureates </b> in <span className='font-italic'>Dubai.</span>
              Central features include the historic <span className='font-italic'> Peace Charter, </span>powerful <b> 21-minute
              speeches </b> by laureates, an exclusive press conference, <span className='font-italic'> Lifetime
              Achievement Award </span> ceremony and an elegant <span className='font-italic'>Gala Dinner. </span> A
              commemorative film and coffee-table book will immortalise this
              significant event.
             </Typography>
         </div>
      </section>

      {/* foundation events section */}
      <section>
        <div className='dynamicBannerwrapper lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>

             <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>
            
             <div className='iconBackground'>
                <img src={imgUrl.foundation} alt='icon'></img>
             </div>
            
             <Typography className='headings sectionHeading blackTitles lifeStorytitle sectionShorttitle'>Foundation Events</Typography>

              <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-10px'>
                Important Wockhardt Foundation events such as medical camp
                inaugurations, charity galas or the annual <span className='font-italic'> Every Smile Counts </span>fundraiser
                are listed. For example: <b> Sept 2020 – Mobile 1000 Van Launch (Nagaland): </b>
                <b> Dr. Huzaifa Khorakiwala </b> to flag off new mobile health clinics in <span className='font-italic'> North East India, </span> expanding healthcare access in remote areas.
              </Typography>

        </div>
      </section>

      {/* movement activities section */}

      <section>
        <div className='whiteSection lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
          
            <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>

                <div className='iconBackground iconYellowbg'>
                <img src={imgUrl.peacekeeperLogo} alt='icon'></img>
                </div>

            <Typography className='headings sectionHeading sectionShorttitle'>I Am Peacekeeper Movement Activities
            </Typography>

            <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-10px'>
               <b> Official Launch of the I Am Peacekeeper Movement & Global Initiatives –
              4th September 2025, Dubai, UAE </b>
            </Typography>

             <Typography className='sectionHeading blackTitles detailedPersonalinfo '>
              The official launch of the <span className='font-italic'> I Am Peacekeeper Movement & Global Initiatives </span>
              will take place on <b> Thursday, 4th September 2025, </b> precisely at <b> 1:47 PM
              GST, </b> at the prestigious <span className='font-italic'> Opera Ballroom, Taj Business Bay, Dubai. </span> This
              landmark occasion will showcase <b> 12 visionary global initiatives, </b> marking
              the dawn of a new era dedicated to peace, unity and humanitarian impact.
              We are honoured by the confirmed presence of esteemed <b> Nobel Peace
              Laureates: Ms. Ouided Bouchamaoui, Dr. Asle Toje </b> and <b> Professor Mohan
              Munasinghe, </b> alongside the anticipated attendance of <b> His Excellency Dr.
              Ali Rashid Al Nuaimi. </b>
              This distinguished gathering promises to inspire profound dialogue and
              meaningful collaboration among global advocates committed to fostering
              enduring peace.
             </Typography>

        </div>
      </section>

      {/* speaking engagement section */}

      <section>
        <div className='dynamicBannerwrapper lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column '>
             <div className='coloredBoxes'>
                <div className='blueBox'></div>
                <div className='purpleBox'></div>
                <div className='blackBox'></div>
                <div className='greyBox'></div>
                <div className='pinkBox'></div>
               </div>
            
             <div className='iconBackground'>
                <img src={imgUrl.engagement} alt='icon'></img>
             </div>
            
             <Typography className='headings sectionHeading blackTitles lifeStorytitle sectionShorttitle'>Speaking Engagements</Typography>

              <Typography className='sectionHeading blackTitles detailedPersonalinfo mt-10px'>
                If <b> Dr. Huzaifa Khorakiwala </b> is slated to speak at universities, business
                forums or international summits organised by others, those will appear
                here too. This allows followers to tune in or attend if possible.
              </Typography>

              {/* <Typography className='sectionHeading blackTitles detailedPersonalinfo smallerPara mt-10px'>
                Each calendar entry expands to show a brief <b> description, </b>  exact <b> timings, location/venue
                    </b>  and any relevant links <br/>
                (for registration, livestream, etc.). You can also filter events by category (Peace, Healthcare, Corporate, etc.) <br/>
                using tags for easier browsing.
              </Typography> */}
        </div>
      </section>
    </div>
  )
}

export default Events
